import React from "react";
import { Flex, Space, Typography } from "antd";
import "./index.scss";

const { Text, Title } = Typography;

const InfoSection = () => {
  return (
    <div className="auth-info-section">
      <div className="content">
        <Space direction="vertical">
          <Title className="title" level={3}>
            About eFone
          </Title>
          <Text className="about">
            Efone is a modern VoIP-based communication platform designed for
            seamless, high-quality voice calling and instant messaging over the
            internet. Whether you are connecting locally or globally.Efone offer
            audio, secure chat and real time Communication features.
          </Text>
        </Space>

        <Space direction="vertical">
          <Title className="title" level={3}>
            Features
          </Title>
          <ul>
            <li>
              <span className="strong">HD VoIP Calling:</span> Make high-quality voice calls
              anywhere in the world using Wi-Fi or mobile data
            </li>
            <li>
              <span className="strong">Cross platform:</span> Available on both mobile and web
              devices for maximum flexibility
            </li>
            <li>
              <span className="strong">Instant Messaging:</span> Available on both mobile and
              web devices for maximum flexibility
            </li>
          </ul>
        </Space>
      </div>
      <div className="images-container">
        <Flex justify="center">
          <img src="/assets/images/discussion.png" alt="" />
        </Flex>
        <Flex align="center" gap={20}>
          <img src="/assets/images/chat.png" alt="" />
          <img src="/assets/images/contacts.png" alt="" />
        </Flex>
      </div>
    </div>
  );
};

export default InfoSection;
